import { createSelector } from "reselect";
import moment from 'moment';

const atypicalPs = state => state.atypicalPS.events;

const getData = (data) => {
  const atypicalPs = [...data];

  atypicalPs.forEach(item => {
    item.displayTimestamp = moment(item.timestamp).format("DD/MM/YYYY");
    item.displaySuccess = item.success ? "yes" : "no";
  });

  return atypicalPs;
};

export default createSelector(
  atypicalPs,
  getData
);



// WEBPACK FOOTER //
// ./src/selectors/get_atypical_ps.js